// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".codeBtn[data-v-2e9bffd6] {\n  width: 85px;\n  margin-left: 25px;\n}\n.codeBtn > span[data-v-2e9bffd6] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
